import { isNil, isEmpty, size, isFunction } from 'lodash';
import ServiceUrls from '@/lib/ServiceUrls';
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex';
import { TimelineMax, TweenMax } from 'gsap';
import FilterMixin from './FilterMixin';

// define a mixin object
export default {
  mixins: [FilterMixin],

  data() {
    return {
      commonShortcuts: {
        F1: this.$t('pageMixin.shortcut.f1'),
        F2: this.$t('pageMixin.shortcut.f2'),
        F3: this.$t('pageMixin.shortcut.f3'),
        F4: this.$t('pageMixin.shortcut.f4'),
        F6: this.$t('pageMixin.shortcut.f6'),
        F7: this.$t('pageMixin.shortcut.f7'),
        F9: this.$t('pageMixin.shortcut.f9'),
        F10: this.$t('pageMixin.shortcut.f10'),
        // 'Ctrl+2': 'Neue Reservierung erstellen',
        'Ctrl+<i class="fal fa-mouse"></i>': this.$t('pageMixin.shortcut.crtlClick'),
      },
    };
  },

  computed: {
    pageShortcuts: function () {
      return {};
    },
  },

  created: function () {
    this.$serviceBus.$on('shortcut.help', this.showKeyboardShortcuts);
  },

  beforeDestroy: function () {
    this.$serviceBus.$off('shortcut.help', this.showKeyboardShortcuts);
  },

  beforeRouteLeave(to, from, next) {
    this.$serviceBus.$emit('keyboardShortcuts.hide');
    next();
  },

  methods: {
    showKeyboardShortcuts() {
      this.$serviceBus.$emit('keyboardShortcuts.show', this.commonShortcuts, this.pageShortcuts);
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/PageMixin.js